import { useEffect, useState } from "react";
import { ButtonCustom } from "../../../../components/custom/button-custom";
import { showToast } from "../../../../components/custom/custom-toast";
import { DetailRow } from "../../../../components/custom/detail-row";
import ImageCustom from "../../../../components/custom/image-custom";
import { ModalCustom } from "../../../../components/custom/modal-custom";
import { IconEllipse, IconUserDefault } from "../../../../components/icons/icon-group";
import { STATUS } from "../../../../constants/status";
import { useFetchData } from "../../../../hooks/useFetch";
import { EmployeeResponse } from "../../../../models/response/employee";
import { API_ADMIN_ROUTER } from "../../../../services/api-config";

interface AdminDetailProps {
  adminId: string;
  isOpenDetail: boolean;
  setIsOpenDetail: (value: boolean) => void;
}

export const AdminDetail = ({ adminId, isOpenDetail, setIsOpenDetail }: AdminDetailProps) => {
  const [dataDetail, setDataDetail] = useState<EmployeeResponse>(new EmployeeResponse());
  const [avatar, setAvatar] = useState<string>("");

  const { request: fetchDataDetail, baseResponse: responsesDetail } = useFetchData.Get<EmployeeResponse>();

  useEffect(() => {
    if (adminId != "") {
      fetchDataDetail({
        endPoint: API_ADMIN_ROUTER.API_DETAIL_ADMIN(adminId),
      });
    }
  }, [adminId]);

  useEffect(() => {
    if (!responsesDetail) return;
    if (responsesDetail.status === 200) {
      setAvatar(responsesDetail.data.avatar);
      setDataDetail(responsesDetail.data);
    } else {
      showToast({ message: responsesDetail.message, type: "error" });
    }
  }, [responsesDetail]);

  const bodyModal = () => {
    return (
      <div className="flex flex-col  gap-3">
        <div className="flex flex-col items-center justify-center w-full relative mb-3">
          <span className="w-24 h-24 relative">
            <ImageCustom
              url={`${avatar || IconUserDefault}`}
              isLocal={false}
              className="w-24 h-24 rounded-full overflow-hidden object-cover"
            />
            <IconEllipse className="w-24 h-24 absolute inset-0 flex items-center justify-center" />
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <DetailRow label="Tên nhân viên:" value={dataDetail?.name} />
          <DetailRow label="Tên đăng nhập:" value={dataDetail?.username} />
          <DetailRow label="Ngày sinh:" value={dataDetail?.birthday} />
          <DetailRow label="Giới tính:" value={dataDetail?.gender === STATUS.ACTIVE ? "Nam" : "Nữ"} />
          <DetailRow label="Số điện thoại:" value={dataDetail?.phone} />
          <DetailRow label="Địa chỉ:" value={dataDetail?.address} />
          <DetailRow label="Ngày bắt đầu làm việc:" value={dataDetail?.joining_date} />
          <DetailRow label="Ngày tạo:" value={dataDetail?.created_at} />
          <DetailRow label="Ngày cập nhật:" value={dataDetail?.updated_at} />
        </div>
      </div>
    );
  };
  const footerModal = () => {
    return (
      <ButtonCustom
        type="button"
        text="Hủy"
        onClick={() => {
          setIsOpenDetail(false);
        }}
        className="bg-gray-100 text-gray-500 hover:bg-gray-400 hover:text-white"
      />
    );
  };

  return (
    <ModalCustom
      isOpen={isOpenDetail}
      setIsOpen={setIsOpenDetail}
      titleModal="Chi tiết admin"
      bodyModal={bodyModal()}
      footerModal={footerModal()}
      modalSize="80%"
    />
  );
};
